import { render, staticRenderFns } from "./QuoteVehicleCustomer.vue?vue&type=template&id=1a12a00a"
import script from "./QuoteVehicleCustomer.vue?vue&type=script&lang=js"
export * from "./QuoteVehicleCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a12a00a')) {
      api.createRecord('1a12a00a', component.options)
    } else {
      api.reload('1a12a00a', component.options)
    }
    module.hot.accept("./QuoteVehicleCustomer.vue?vue&type=template&id=1a12a00a", function () {
      api.rerender('1a12a00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteVehicleCustomer.vue"
export default component.exports